import { render, staticRenderFns } from "./PriceCalculation.vue?vue&type=template&id=07c48c4a&scoped=true&"
import script from "./PriceCalculation.vue?vue&type=script&lang=js&"
export * from "./PriceCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c48c4a",
  null
  
)

export default component.exports